import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { addCaregiver } from './endpoints/addCaregiver';
import { addRelatedPerson } from './endpoints/addRelatedPerson';
import { checkCaregiverPermission } from './endpoints/checkCaregiverPermission';
import { getCaregiversDetails } from './endpoints/getCaregiversDetails';
import { getCaregiversHealthRecordTypes } from './endpoints/getCaregiversHealthRecordTypes';
import { getRelatedPeople, TAG_GET_RELATEDPEOPLE } from './endpoints/getRelatedPeople';
import { getRelatedPersonDetails } from './endpoints/getRelatedPersonDetails';
import { updateCaregiver } from './endpoints/updateCaregiver';
import { updateCaregiverStatus } from './endpoints/updateCaregiverStatus';
import { updateCaregiverToFullConsent } from './endpoints/updateCaregiverToFullConsent';
import { updateRelatedPerson } from './endpoints/updateRelatedPerson';
import { updateRelatedPersonStatus } from './endpoints/updateRelatedPersonStatus';
import { verifyCaregiverNRIC } from './endpoints/verifyCaregiverNRIC';
import { verifyCaregiverRequest } from './endpoints/verifyCaregiverRequest';

export const caregiversApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      addCaregiver: addCaregiver(builder),
      addRelatedPerson: addRelatedPerson(builder),
      checkCaregiverPermission: checkCaregiverPermission(builder),
      getCaregiverDetails: getCaregiversDetails(builder),
      getCaregiversHealthRecordTypes: getCaregiversHealthRecordTypes(builder),
      getRelatedPeople: getRelatedPeople(builder),
      getRelatedPersonDetails: getRelatedPersonDetails(builder),
      updateCaregiver: updateCaregiver(builder),
      updateCaregiverStatus: updateCaregiverStatus(builder),
      updateCaregiverToFullConsent: updateCaregiverToFullConsent(builder),
      updateRelatedPerson: updateRelatedPerson(builder),
      updateRelatedPersonStatus: updateRelatedPersonStatus(builder),
      verifyCaregiverNRIC: verifyCaregiverNRIC(builder),
      verifyCaregiverRequest: verifyCaregiverRequest(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [TAG_GET_RELATEDPEOPLE],
  });

export const {
  useAddCaregiverMutation,
  useAddRelatedPersonMutation,
  useGetCaregiverDetailsQuery,
  useGetCaregiversHealthRecordTypesQuery,
  useGetRelatedPeopleQuery,
  useGetRelatedPersonDetailsQuery,
  useLazyCheckCaregiverPermissionQuery,
  useLazyVerifyCaregiverNRICQuery,
  useLazyVerifyCaregiverRequestQuery,
  useUpdateCaregiverMutation,
  useUpdateCaregiverStatusMutation,
  useUpdateCaregiverToFullConsentMutation,
  useUpdateRelatedPersonMutation,
  useUpdateRelatedPersonStatusMutation,
} = caregiversApi;
